import axiosInstanceBuilder from "../axiosInstance"
const axiosInstance = axiosInstanceBuilder('api')

export const getAllTicket = (params: any) => {
  return axiosInstance.get('/tickets', {
    params
  })
}

export const getBlockingTickets = (params: any) => {
  return axiosInstance.get('/tickets/blocking-tickets', {
    params: {
      ...params,
      departmentId: 2
    }
  })
}

export const getSingleTicket = (id: string) => {
  return axiosInstance.get(`/tickets/${id}`)
}

export const getTicketContents = (id: string) => {
  return axiosInstance.get(`/tickets/${id}/content`)
}

export const getStatusCounts = () => {
  return axiosInstance.get(`/tickets/count`)
}

export const getStatusCountsByCategory = () => {
  return axiosInstance.get(`/tickets/count/category`)
}

export const getCategories = (params: any) => {
  return axiosInstance.get('/categories', {
    params
  })
}
export const getSubjects = (params: any) => {
  return axiosInstance.get('/subjects', {
    params
  })
}
export const getDepartments = (params?: any) => {
  return axiosInstance.get('/departments', {
    params
  })
}
export const getUsers = (params?: any) => {
  return axiosInstance.get('/users', {
    params
  })
}

export const getUsersDepartment = (params?: any) => {
  return axiosInstance.get('/users/department', {
    params
  })
}

export const downloadFile = (id: number, ticketId: string, name: string) => {
  return fetch(`${axiosInstance.defaults.baseURL}/tickets/${ticketId}/content/${id}/file`, {
    headers: {
      authorization: 'Bearer ' + localStorage.getItem('token')
    }
  })
}
